import { action, createRequestTypes } from 'utils/actions'

export const ENTITIES_PARTNER_SETTINGS = createRequestTypes('ENTITIES_PARTNER_SETTINGS')

export const partnerSettings = {
  request: partnerId => action(ENTITIES_PARTNER_SETTINGS.REQUEST, { partnerId }),
  success: (partnerId, response) => action(ENTITIES_PARTNER_SETTINGS.SUCCESS, { partnerId, response }),
  failure: (partnerId, error) => action(ENTITIES_PARTNER_SETTINGS.FAILURE, { partnerId, error }),
}



/** WEBPACK FOOTER **
 ** ./src/actions/entities/partner-settings/partner-settings-actions.js
 **/